import { ReportSearchModel, ReportCardType } from '@/types';
import ReportCard from './report/ReportCard';

type EntityCardModel = {
  data: ReportSearchModel;
  cardType: ReportCardType;
  size?: EntityCardSize;
  className?: string;
  onClick?: (e: React.MouseEvent, data: ReportSearchModel) => void;
};

export enum EntityCardSize {
  SMALL = 'small',
  LARGE = 'large',
  AUTO = 'auto',
}

export const EntityCard = ({ data, cardType, ...props }: EntityCardModel) => {
  if (cardType === 'VideoCardModel') {
    return <div>Video</div>;
  } else if (cardType === 'EventCardModel') {
    return <div>Event</div>;
  } else {
    return <ReportCard data={data} {...props} />;
  }
};
